import { Logo } from "./Logo";
export type { Props } from "./Logo.types";
export { info } from "./Logo.info";

export default Logo;
